import {
  FETCH_GLOBAL_SETTINGS_REQUEST,
  FETCH_GLOBAL_SETTINGS_SUCCESS,
  SET_GLOBAL_SETTING,
  FETCH_PERSONAL_SETTINGS_REQUEST,
  FETCH_PERSONAL_SETTINGS_SUCCESS,
  SET_PERSONAL_SETTING,
  CREATE_PERSONAL_SETTINGS,
  FETCH_PERSONAL_DISPLAYSETTINGS_REQUEST,
  FETCH_PERSONAL_DISPLAYSETTINGS_SUCCESS,
  SET_PERSONAL_DISPLAYSETTING,
  CREATE_PERSONAL_DISPLAYSETTINGS,
} from "actions/types";

import {
  globalSettingsRead,
  globalSettingsSet,
  personalSettingsSet,
  personalSettingsRead,
  personalSettingsCreate,
  personalDisplaySettingsSet,
  personalDisplaySettingsRead,
  personalDisplaySettingsCreate,
} from "../api";
import {
  dataFailure,
  dataSuccess,
} from "./general";

const fetchGlobalSettingsRequest = () => {
  return {
    type: FETCH_GLOBAL_SETTINGS_REQUEST
  }
}

const fetchGlobalSettingsSuccess = (settings) => {
  return {
    type: FETCH_GLOBAL_SETTINGS_SUCCESS,
    payload: settings
  }
}

export const fetchGlobalSettings = (values) => {
  return async (dispatch) => {
    // dispatch(dataStartLoading())
    await dispatch(fetchGlobalSettingsRequest())
    try {
      const JSONData = await dispatch(globalSettingsRead(values))
      await dispatch(fetchGlobalSettingsSuccess(JSONData))
      // dispatch(dataEndLoading())
    } catch(err) {
      await dispatch(dataFailure(err))
      // dispatch(dataEndLoading())
    }
  }
}

const setGlobalSettingsData = (values) => {
  return {
    type: SET_GLOBAL_SETTING,
    payload: values
  }
}

export const setGlobalSettings = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(globalSettingsSet(values));
      await dispatch(setGlobalSettingsData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err));
    }
  }
}

const fetchPersonalSettingsRequest = () => {
  return {
    type: FETCH_PERSONAL_SETTINGS_REQUEST
  }
}

const fetchPersonalSettingsSuccess = (settings) => {
  return {
    type: FETCH_PERSONAL_SETTINGS_SUCCESS,
    payload: settings
  }
}

export const fetchPersonalSettings = (values) => {
  return async (dispatch) => {
    // dispatch(dataStartLoading())
    await dispatch(fetchPersonalSettingsRequest())
    try {
      const JSONData = await dispatch(personalSettingsRead(values))
      await dispatch(fetchPersonalSettingsSuccess(JSONData))
      // dispatch(dataEndLoading())
    } catch(err) {
      await dispatch(dataFailure(err))
      // dispatch(dataEndLoading())
    }
  }
}

const setPersonalSettingsData = (values) => {
  return {
    type: SET_PERSONAL_SETTING,
    payload: values
  }
}

export const setPersonalSettings = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(personalSettingsSet(values));
      await dispatch(setPersonalSettingsData(values));
      if(!values.noSuccessMessage){
        await dispatch(dataSuccess());
      }
    } catch (err) {
      await dispatch(dataFailure(err));
    }
  }  
}

const createPersonalSettingsData = (values) => {
  return {
    type: CREATE_PERSONAL_SETTINGS,
    payload: values,
  };
};

export const createPersonalSettings = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(personalSettingsCreate(values));
      await dispatch(createPersonalSettingsData(values));
    } catch (err) {
      await dispatch(dataFailure(err));
    }
  }  
}

const fetchPersonalDisplaySettingsRequest = () => {
  return {
    type: FETCH_PERSONAL_DISPLAYSETTINGS_REQUEST
  }
}

const fetchPersonalDisplaySettingsSuccess = (settings) => {
  return {
    type: FETCH_PERSONAL_DISPLAYSETTINGS_SUCCESS,
    payload: settings,
  };
};

export const fetchPersonalDisplaySettings = (values) => {
  return async (dispatch) => {
    // dispatch(dataStartLoading())
    await dispatch(fetchPersonalDisplaySettingsRequest());
    try {
      const JSONData = await dispatch(personalDisplaySettingsRead(values));
      await dispatch(fetchPersonalDisplaySettingsSuccess(JSONData));
      // dispatch(dataEndLoading())
    } catch (err) {
      await dispatch(dataFailure(err));
      // dispatch(dataEndLoading())
    }
  };
};

const setPersonalDisplaySettingsData = (values) => {
  return {
    type: SET_PERSONAL_DISPLAYSETTING,
    payload: values,
  };
};

export const setPersonalDisplaySettings = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(personalDisplaySettingsSet(values));
      await dispatch(setPersonalDisplaySettingsData(values));
      await dispatch(dataSuccess());
    } catch (err) {
      await dispatch(dataFailure(err));
    }
  };
};

const createPersonalDisplaySettingsData = (values) => {
  return {
    type: CREATE_PERSONAL_DISPLAYSETTINGS,
    payload: values,
  };
};

export const createPersonalDisplaySettings = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(personalDisplaySettingsCreate(values));
      await dispatch(createPersonalDisplaySettingsData(values));
    } catch (err) {
      await dispatch(dataFailure(err));
    }
  };
};
